.container {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-width: 0;
  background: var(--color-background-secondary);
  border-radius: 0.6rem;
  padding: 1.6rem;
  user-select: none;

  &[data-selected='true'] {
    box-shadow: inset 0 0 0 1.5px var(--color-secondary);
  }

  &:hover {
    cursor: pointer;
  }
}

.modal-container {
  position: absolute;
  top: 50%;
  right: 1.6rem;
  transform: translateY(-50%);
  cursor: pointer;
}

.folder-name {
  color: white;
  font-weight: 400;
  font-size: 1.6rem;
  margin-right: auto;
}

.folder-image {
  margin-right: 1.2rem;

  img {
    width: 2.4rem;
  }
}

.folder-link {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
}
